import { OnInit, Component, ViewChild, EventEmitter, Output, Input } from "@angular/core";
import { DataListModel } from "../../shared/config";
import { TranslateService } from "../../shared/translate/translate.service";
import { AuthService } from "../../shared/models/auth.service";
import { RoleAvailabilityService } from "../models/roleavailability.service";
import { RoleModel } from "../../role-management/models/role.model";

@Component({
  selector: 'wego-assign-role-to-customer-popup',
  template: require('../views/assign-role-to-customer-popup.component.html'),
  providers: [RoleAvailabilityService],
})

export class AssignRoleToCustomerComponent implements OnInit {
  isParentCheck: boolean = false;
  isLoading: boolean;
  DataListModel: DataListModel;
  roleList: RoleModel[];
  apiErrorMsg: string;
  private breadCrumbTitle: string;
  LblIcon: string;
  LblAssignToCustomer: string;
  _customerHashId: string;

  constructor(private translate: TranslateService,
    private roleAvailabilityService: RoleAvailabilityService,
    private authService: AuthService
  ) { }

  @Output('onConfirm') onConfirm = new EventEmitter();
  @ViewChild('assignToCustomerModal') public assignToCustomerModal: any;

  @Input()
  set customerHashId(customerHashId: string) {
    this._customerHashId = customerHashId;
  }
  get customerHashId() { return this._customerHashId; }

  ngOnInit() {
    this.LblAssignToCustomer = this.translate.instant('LblAssign') + " " + this.translate.instant('LblRole');
    this.LblIcon = 'fa fa-plus-square';
    this.breadCrumbTitle = this.LblAssignToCustomer;
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["roleName", "entity", "roleType"];
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";   
    this.GetRoleList();    
    this.assignToCustomerModal.show();
  }

  public hide(): void {
    this.assignToCustomerModal.hide();
  }

  private GetRoleList() {
    this.isLoading = true;
    this.roleAvailabilityService.GetRoleForAssignToCustomer(this.DataListModel, this.customerHashId)
      .subscribe(
      res => {
        this.roleList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetRoleList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetRoleList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.roleList.forEach(x => x.isChecked = isChecked);
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetRoleList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetRoleList();
  }

  private OnAdd(event: any) {
    let roleModelList: RoleModel[];
    roleModelList = this.roleList.filter(x => x.isChecked);
    this.OnSuccessSelect(roleModelList);
    this.assignToCustomerModal.hide();
  }

  private OnSuccessSelect(roleModelList: RoleModel[]) {
    this.onConfirm.emit({ RoleModelList: roleModelList })
  }

  get isAnyChecked(): boolean {
    if (this.roleList && this.roleList.length > 0) {
      let isCheck = this.roleList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.roleList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }
      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/roleavailability/components/assign-role-to-customer-popup.component.ts